import { combineReducers } from '@reduxjs/toolkit';

import { baseApi } from 'store/baseApi';
import { uiSlice } from 'store/entities/ui/slice';
import { usersSlice } from 'store/entities/users/slice';
import { dashboardSlice } from 'store/entities/dashboard/slice';

const reducers = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [usersSlice.name]: usersSlice.reducer,
  [dashboardSlice.name]: dashboardSlice.reducer,
  [uiSlice.name]: uiSlice.reducer,
});

export default reducers;
